"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationProvider = exports.useNotification = void 0;
const react_1 = __importStar(require("react"));
const common_utils_1 = require("@zapier/common-utils");
const Notifications_1 = __importDefault(require("./Notifications"));
const defaultNotificationContext = {
    clearNotification: function () { },
    createNotification: function () { },
};
const NotificationContext = react_1.createContext(defaultNotificationContext);
function useNotification() {
    return react_1.useContext(NotificationContext);
}
exports.useNotification = useNotification;
function NotificationProvider(props) {
    const [notifications, setNotifications] = react_1.default.useState([]);
    const clearNotification = react_1.useCallback((id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    }, []);
    const createNotification = react_1.useCallback((options) => {
        setNotifications(prev => [...prev, Object.assign(Object.assign({}, options), { id: common_utils_1.uid() })]);
    }, []);
    const notificationTimeout = props.notificationTimeout || 5000;
    const value = {
        clearNotification,
        createNotification,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Notifications_1.default, { notifications: notifications, onDismiss: clearNotification, timeout: notificationTimeout }),
        react_1.default.createElement(NotificationContext.Provider, { value: value }, props.children)));
}
exports.NotificationProvider = NotificationProvider;
